import { useMutation } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { CreateViewRequest, HttpResponse, View } from "@/types";

export function useCreateView() {
  const mutation = useMutation({
    mutationFn: async ({
      createViewRequest,
    }: {
      createViewRequest: CreateViewRequest;
    }) => {
      const path = `views`;
      const res = await guacHttpClient.post<
        View,
        HttpResponse<View>,
        CreateViewRequest
      >(path, createViewRequest);

      return res.data;
    },
  });

  return mutation;
}
